<script>
  import { values, td_values, format } from '../stores/simulation'
  import { getDictionary } from '../stores/locale';

  const dict = getDictionary()

  $: elwi = format($td_values.elwi, 0, '**')
  $: pvpi = format($td_values.pvpi, 1, '*.*')
  $: td_cipc = format($td_values.td_cipc, 2, '*.**')
  $: gedi = format($td_values.gedi, 0, '**')
  $: gef = format($td_values.gef, 0, '***')
  $: cfi = format($td_values.cfi, 1, '*.*')

  $: cipc = format($td_values.dirty || $values.sendCO ? $values.derived.cipc : null, 2, '*.**')
  $: svv = format($td_values.dirty || $values.sendCO ? $values.derived.svv : null, 0, '**')
  $: svri = format($values.derived.svri, 0, '****')

  $: ea_dyn = format($values.derived.ea_dyn, 2, '*.**')
  $: cpi = format($values.derived.cpi, 2, '*.**')
  $: d_pmx = format($values.derived.d_pmx, 0, '**')

  const range = (x, verylow, low, high, veryhigh, dependentOnTd = true) => {
    if (!$td_values.dirty && dependentOnTd == true) return 'inactive'
    if (verylow && x < verylow) return 'verylow'
    if (low && x < low) return 'low'
    if (veryhigh && x > veryhigh) return 'veryhigh'
    if (high && x > high) return 'high'
    return 'ok'
  }

  const t = 0.2

  $: elwi_range = range($td_values.elwi, 3, null, 7, 15)
  $: pvpi_range = range($td_values.pvpi, 1, null, null, 3)
  $: gedi_range = range($td_values.gedi, 680 * (1 - t), 680, 800, 800 * (1 + t))

  $: svv_range = $values.sendCO
    ? range($values.derived.svv, null, null, 10, 10 * (1 + t), false)
    : range($values.derived.svv, null, null, 10, 10 * (1 + t))
  $: cipc_range = $values.sendCO
    ? range($values.derived.cipc, 3 * (1 - t), 3, 5, 5 * (1 + t), false)
    : range($values.derived.cipc, 3 * (1 - t), 3, 5, 5 * (1 + t))

  $: gef_range = range($td_values.gef, 25 * (1 - t), 25, 35, 35 * (1 + t))
  $: cfi_range = range($td_values.cfi, 4.5 * (1 - t), 4.5, 4.6, 4.6 * (1 + t))
  $: svri_range = range($values.derived.svri, 1700 * (1 - t), 1700, 2400, 2400 * (1 + t), false)

  $: cpi_indicator = $values.derived.cpi < 0.5 ? 'verylow' : 'ok'

  $: gef_nromalized =
    gef !== Infinity && gef !== -Infinity && gef !== 'Infinity' && gef !== '-Infinity' ? gef : '***'
  $: cfi_normalized =
    cfi !== Infinity && cfi !== -Infinity && cfi !== 'Infinity' && cfi !== '-Infinity' ? cfi : '*.*'

  const handleOpenTD = () => {
    if ($values.td_available) {
      $values.td_open = true
    } else {
      alert('App has not received a simulation signal yet.')
    }
  }
</script>

<div class="wrapper">
  <svg
    version="1.1"
    viewBox="0 0 464.58 425.85"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <defs>
      <g transform="translate(-.39 .69)">
        <g id="pvpi-states">
          <path
            id="pvpi-inactive"
            class="cls-21"
            d="m217.32 14.54v9.92a6.55 6.55 0 0 1-4.13 6.12 47.12 47.12 0 1 0 34 0 6.55 6.55 0 0 1-4.13-6.12v-9.92"
          />
          <path
            id="pvpi-veryhigh"
            class="cls-22"
            d="m217.32 14.54v9.92a6.55 6.55 0 0 1-4.13 6.12 47.12 47.12 0 1 0 34 0 6.55 6.55 0 0 1-4.13-6.12v-9.92"
          />
          <path
            id="pvpi-high"
            class="cls-23"
            d="m217.32 14.54v9.92a6.55 6.55 0 0 1-4.13 6.12 47.12 47.12 0 1 0 34 0 6.55 6.55 0 0 1-4.13-6.12v-9.92"
          />
          <path
            id="pvpi-ok"
            class="cls-24"
            d="m217.32 14.54v9.92a6.55 6.55 0 0 1-4.13 6.12 47.12 47.12 0 1 0 34 0 6.55 6.55 0 0 1-4.13-6.12v-9.92"
          />
          <path
            id="pvpi-low"
            class="cls-25"
            d="m217.32 14.54v9.92a6.55 6.55 0 0 1-4.13 6.12 47.12 47.12 0 1 0 34 0 6.55 6.55 0 0 1-4.13-6.12v-9.92"
          />
          <path
            id="pvpi-verylow"
            class="cls-25"
            d="m217.32 14.54v9.92a6.55 6.55 0 0 1-4.13 6.12 47.12 47.12 0 1 0 34 0 6.55 6.55 0 0 1-4.13-6.12v-9.92"
          />
        </g>
        <g id="elwi-states">
          <g id="elwi-inactive">
            <g class="cls-26" clip-path="url(#clip-path-2)">
              <circle class="cls-27" cx="230.13" cy="74.43" r="41.45" />
            </g>
          </g>
          <g id="elwi-veryhigh">
            <g class="cls-28" clip-path="url(#clip-path-3)">
              <circle class="cls-9" cx="230.13" cy="74.43" r="41.45" />
            </g>
          </g>
          <g id="elwi-high">
            <g class="cls-29" clip-path="url(#clip-path-4)">
              <circle class="cls-9" cx="230.13" cy="74.43" r="41.45" />
            </g>
          </g>
          <g id="elwi-ok">
            <g class="cls-26" clip-path="url(#clip-path-2)">
              <circle class="cls-9" cx="230.13" cy="74.43" r="41.45" />
            </g>
          </g>
          <g id="elwi-low">
            <g class="cls-26" clip-path="url(#clip-path-2)">
              <circle class="cls-30" cx="230.13" cy="74.43" r="41.45" />
            </g>
          </g>
          <g id="elwi-verylow">
            <g class="cls-26" clip-path="url(#clip-path-2)">
              <circle class="cls-30" cx="230.13" cy="74.43" r="41.45" />
            </g>
          </g>
        </g>
        <g id="gedi-states">
          <g id="gedi-inactive" class="cls-31">
            <circle
              class="cls-32"
              transform="rotate(-80.78 227.6 243.13)"
              cx="227.58"
              cy="243.13"
              r="45.96"
            />
            <path
              class="cls-33"
              d="m235.54 276.38a5.64 5.64 0 0 0 4.88-2.46c1.81-2.52 2.9-7.18 2.92-12.45s-1.05-10.23-2.8-12.91a25.47 25.47 0 0 0-1.87-2.58l-0.07-0.08v-0.11a19.36 19.36 0 0 1-0.22-3.66 9 9 0 0 1 0.58-3.11c0.26-0.61 0.57-1.15 1.46-1.15h0.1l7.81 0.33 0.07-7.46c-0.69-0.11-1.46-0.18-2.28-0.26a18.08 18.08 0 0 1-5.38-1l-0.12-0.06-0.06-0.12a4.26 4.26 0 0 1-0.53-3 0.92 0.92 0 0 1 0.52-0.57 9.05 9.05 0 0 1 3.06-0.32c1.57 0 3.38 0.1 4.58 0.17h0.06v-2.16c0-1.67 0-3.33 0.06-5h-0.31c-7.67 0-18.27 1.1-25.22 6.38l-0.42 0.32-0.16-0.5c-1.11-3.41-3.67-11.26-4.09-12.35l-0.23-0.59h-0.63c-0.63 0-1.22 0.09-1.8 0.15-0.76 0.07-1.55 0.15-2.39 0.16 0.85 8.94 0.92 14.94-4.26 22a20 20 0 0 0-3.24 5.54c-1 3.39-0.32 7.68 0.28 11.47v0.08c0.1 0.62 0.2 1.23 0.3 2a4.61 4.61 0 0 0 1 1.86 5 5 0 0 1 0.91 1.65c0.51 2.55 2.3 5.37 5.18 8.15a36 36 0 0 0 10.26 6.9c0.45 0.19 1.17 0.58 2 1l0.08 0.05c3.1 1.69 6.73 3.7 10 3.65z"
            />
            <path
              class="cls-34"
              d="m211.26 258.28c-0.54-1.83 3.06-2.49 7.23-2s3.06-11 9.42 4.32c3.55 8.53 11.32 15.42 5.35 13.52-6.47-2.04-19.79-8.48-22-15.84z"
            />
            <path
              class="cls-35"
              d="m235.46 246.23c-1.45-1.22-2 4.38-7.89 5.13-4.16 0.53 9.54 26.26 11.51 20.31 2.92-8.91 2.23-20.52-3.62-25.44z"
            />
            <path
              class="cls-34"
              d="m210.37 250.27c0.43-3.82 5-8.88 7.69-6.14 3.15 3.2 4.17 10.67 0.34 10.37-4.4-0.33-8.4-0.41-8.03-4.23z"
            />
            <path
              class="cls-36"
              d="m229.06 248.7c3.22-1.44 7.59-6.87 3.76-7-5.61-0.15-10.38-2.1-9.5 0.87s2.92 7.43 5.74 6.13z"
            />
          </g>
          <g id="gedi-veryhigh">
            <circle class="cls-37" cx="227.58" cy="243.13" r="45.96" />
            <path
              class="cls-38"
              d="m227.58 205.82h-2.84c-0.39 0-0.77 0.06-1.15 0.11l0.32 3a34.43 34.43 0 0 1 3.67-0.2v-3zm-7.94 0.85c-0.81 0.18-1.62 0.38-2.41 0.61h-0.31l-1.08 0.35 0.94 2.84a35.77 35.77 0 0 1 3.55-1l-0.64-2.93zm-7.57 2.52a37.19 37.19 0 0 0-3.54 1.86l1.53 2.58a33.7 33.7 0 0 1 3.26-1.71zm-6.87 4.09c-0.3 0.22-0.59 0.45-0.88 0.69l-0.07 0.06h-0.16l-0.07 0.05c-0.64 0.52-1.26 1.06-1.86 1.63l2.05 2.19a33.55 33.55 0 0 1 2.82-2.36l-1.81-2.4zm-5.83 5.45q-1.05 1.2-2 2.49l-0.08 0.1-0.07 0.1h-0.22l2.47 1.71a35.1 35.1 0 0 1 2.25-2.9l-2.26-2zm-4.56 6.55a39.76 39.76 0 0 0-1.72 3.61l2.77 1.15a33.7 33.7 0 0 1 1.59-3.32zm-3.05 7.38c-0.12 0.42-0.23 0.83-0.34 1.25v0.07q-0.27 1.11-0.48 2.25l3 0.52a34.35 34.35 0 0 1 0.83-3.58l-2.88-0.84zm-1.39 7.87c0 0.4-0.05 0.8-0.07 1.21v0.26 1l3-0.11v-1.28c0-0.8 0-1.61 0.08-2.4l-3-0.2zm3.26 7.55-3 0.43v0.14c0.1 0.68 0.22 1.34 0.36 2v0.06c0.07 0.31 0.14 0.63 0.22 0.94v0.09l2.91-0.75a36.39 36.39 0 0 1-0.72-3.6zm1.82 7.11-2.8 1.05c0.14 0.39 0.3 0.78 0.46 1.17l0.06 0.16a1.17 1.17 0 0 0 0 0.11v0.38h0.16v0.07l0.25 0.51 2.68-1.35a34.6 34.6 0 0 1-1.48-3.36zm3.31 6.55-2.52 1.63 0.22 0.34h0.13l0.05 0.08c0.58 0.84 1.18 1.65 1.82 2.44l2.33-1.89a33.22 33.22 0 0 1-2.16-3zm4.63 5.71-2.12 2.12a37.82 37.82 0 0 0 3 2.67l1.88-2.34a33.7 33.7 0 0 1-2.74-2.45zm5.72 4.59-1.61 2.53c0.38 0.25 0.78 0.49 1.17 0.72l0.1 0.06h0.34c0.59 0.33 1.19 0.65 1.79 1l1.34-2.68a36.08 36.08 0 0 1-3.2-1.82zm6.57 3.28-1 2.81 0.91 0.32h1.29c0.52 0.15 1.05 0.3 1.57 0.43l0.73-2.91a36.42 36.42 0 0 1-3.51-1.08zm7.12 1.78-0.41 3a37.85 37.85 0 0 0 3.87 0.34h0.11l0.1-3a34.49 34.49 0 0 1-3.67-0.32zm11-0.23a34.36 34.36 0 0 1-3.65 0.47l0.22 3a37.12 37.12 0 0 0 4-0.51l-0.54-2.95zm7-2.09a35.63 35.63 0 0 1-3.46 1.24l0.85 2.87c0.65-0.19 1.3-0.4 1.93-0.63h1.7l-1.16-2.77zm6.43-3.55a32.52 32.52 0 0 1-3.12 1.95l1.45 2.63c0.66-0.37 1.31-0.75 1.95-1.16h0.33l0.09-0.06 1-0.65-1.72-2.46zm5.53-4.83a33.55 33.55 0 0 1-2.64 2.56l2 2.26c0.46-0.41 0.92-0.82 1.36-1.25h0.14c0.47-0.45 0.92-0.92 1.36-1.4l-2.2-2zm4.38-5.9a35.43 35.43 0 0 1-2 3.07l2.4 1.79c0.58-0.78 1.13-1.58 1.65-2.41h0.05c0.15-0.24 0.31-0.49 0.45-0.75l-2.58-1.52zm3-6.69a34.74 34.74 0 0 1-1.33 3.43l2.73 1.24a37.38 37.38 0 0 0 1.45-3.73zm1.52-7.18a32 32 0 0 1-0.57 3.64l2.94 0.62v-0.08c0.09-0.44 0.17-0.89 0.25-1.33v-0.15c0.09-0.6 0.16-1.2 0.22-1.81l-3-0.31zm2.94-7.68-3 0.33a34.62 34.62 0 0 1 0.22 3.68h3v-1.57c0-0.35-0.07-0.69-0.11-1zm-1.73-7.79-2.84 1a33.15 33.15 0 0 1 1 3.54l2.97-0.7c0-0.17-0.08-0.34-0.11-0.5v-0.06c-0.26-1.06-0.57-2.11-0.92-3.14zm-3.36-7.25-2.51 1.55a36.09 36.09 0 0 1 1.73 3.25l2.72-1.27a36.14 36.14 0 0 0-1.88-3.53zm-4.82-6.36-2.19 2.06a33.64 33.64 0 0 1 2.38 2.81l2.39-1.82-0.33-0.42h-0.15l-0.65-0.79-0.08-0.1-0.06-0.07h-0.14l-0.87-0.95zm-6.07-5.19-1.62 2.47a34.64 34.64 0 0 1 2.91 2.24l2-2.28a37.46 37.46 0 0 0-3.17-2.43zm-7-3.79-1.14 2.77c1.13 0.47 2.25 1 3.33 1.57l1.42-2.64-0.17-0.09h-0.39c-1-0.5-2-1-3-1.38zm-7.68-2.2-0.51 3a33.69 33.69 0 0 1 3.58 0.81l0.83-2.88a39.35 39.35 0 0 0-3.9-0.89zm-6.39-0.55v3c0.74 0 1.49 0 2.23 0.08l0.19-3c-0.62 0-1.25-0.06-1.88-0.07h-0.54z"
            />
            <path
              class="cls-33"
              d="m235.54 276.38a5.64 5.64 0 0 0 4.88-2.46c1.81-2.52 2.9-7.18 2.92-12.45s-1.05-10.23-2.8-12.91a25.47 25.47 0 0 0-1.87-2.58l-0.07-0.08v-0.11a19.36 19.36 0 0 1-0.22-3.66 9 9 0 0 1 0.58-3.11c0.26-0.61 0.57-1.15 1.46-1.15h0.1l7.81 0.33 0.07-7.46c-0.69-0.11-1.46-0.18-2.28-0.26a18.08 18.08 0 0 1-5.38-1l-0.12-0.06-0.06-0.12a4.26 4.26 0 0 1-0.53-3 0.92 0.92 0 0 1 0.52-0.57 9.05 9.05 0 0 1 3.06-0.32c1.57 0 3.38 0.1 4.58 0.17h0.06v-2.16c0-1.67 0-3.33 0.06-5h-0.31c-7.67 0-18.27 1.1-25.22 6.38l-0.42 0.32-0.16-0.5c-1.11-3.41-3.67-11.26-4.09-12.35l-0.23-0.59h-0.63c-0.63 0-1.22 0.09-1.8 0.15-0.76 0.07-1.55 0.15-2.39 0.16 0.85 8.94 0.92 14.94-4.26 22a20 20 0 0 0-3.24 5.54c-1 3.39-0.32 7.68 0.28 11.47v0.08c0.1 0.62 0.2 1.23 0.3 2a4.61 4.61 0 0 0 1 1.86 5 5 0 0 1 0.91 1.65c0.51 2.55 2.3 5.37 5.18 8.15a36 36 0 0 0 10.26 6.9c0.45 0.19 1.17 0.58 2 1l0.08 0.05c3.1 1.69 6.73 3.7 10 3.65z"
            />
            <path
              class="cls-34"
              d="m211.26 258.28c-0.54-1.83 3.06-2.49 7.23-2s3.06-11 9.42 4.32c3.55 8.53 11.32 15.42 5.35 13.52-6.47-2.04-19.79-8.48-22-15.84z"
            />
            <path
              class="cls-35"
              d="m235.46 246.23c-1.45-1.22-2 4.38-7.89 5.13-4.16 0.53 9.54 26.26 11.51 20.31 2.92-8.91 2.23-20.52-3.62-25.44z"
            />
            <path
              class="cls-34"
              d="m210.37 250.27c0.43-3.82 5-8.88 7.69-6.14 3.15 3.2 4.17 10.67 0.34 10.37-4.4-0.33-8.4-0.41-8.03-4.23z"
            />
            <path
              class="cls-36"
              d="m229.06 248.7c3.22-1.44 7.59-6.87 3.76-7-5.61-0.15-10.38-2.1-9.5 0.87s2.92 7.43 5.74 6.13z"
            />
          </g>
          <g id="gedi-high">
            <circle class="cls-39" cx="227.58" cy="243.13" r="45.96" />
            <path
              class="cls-38"
              d="m227.58 205.82h-2.84c-0.39 0-0.77 0.06-1.15 0.11l0.32 3a34.43 34.43 0 0 1 3.67-0.2v-3zm-7.94 0.85c-0.81 0.18-1.62 0.38-2.41 0.61h-0.31l-1.08 0.35 0.94 2.84a35.77 35.77 0 0 1 3.55-1l-0.64-2.93zm-7.57 2.52a37.19 37.19 0 0 0-3.54 1.86l1.53 2.58a33.7 33.7 0 0 1 3.26-1.71zm-6.87 4.09c-0.3 0.22-0.59 0.45-0.88 0.69l-0.07 0.06h-0.16l-0.07 0.05c-0.64 0.52-1.26 1.06-1.86 1.63l2.05 2.19a33.55 33.55 0 0 1 2.82-2.36l-1.81-2.4zm-5.83 5.45q-1.05 1.2-2 2.49l-0.08 0.1-0.07 0.1h-0.22l2.47 1.71a35.1 35.1 0 0 1 2.25-2.9l-2.26-2zm-4.56 6.55a39.76 39.76 0 0 0-1.72 3.61l2.77 1.15a33.7 33.7 0 0 1 1.59-3.32zm-3.05 7.38c-0.12 0.42-0.23 0.83-0.34 1.25v0.07q-0.27 1.11-0.48 2.25l3 0.52a34.35 34.35 0 0 1 0.83-3.58l-2.88-0.84zm-1.39 7.87c0 0.4-0.05 0.8-0.07 1.21v0.26 1l3-0.11v-1.28c0-0.8 0-1.61 0.08-2.4l-3-0.2zm3.26 7.55-3 0.43v0.14c0.1 0.68 0.22 1.34 0.36 2v0.06c0.07 0.31 0.14 0.63 0.22 0.94v0.09l2.91-0.75a36.39 36.39 0 0 1-0.72-3.6zm1.82 7.11-2.8 1.05c0.14 0.39 0.3 0.78 0.46 1.17l0.06 0.16a1.17 1.17 0 0 0 0 0.11v0.38h0.16v0.07l0.25 0.51 2.68-1.35a34.6 34.6 0 0 1-1.48-3.36zm3.31 6.55-2.52 1.63 0.22 0.34h0.13l0.05 0.08c0.58 0.84 1.18 1.65 1.82 2.44l2.33-1.89a33.22 33.22 0 0 1-2.16-3zm4.63 5.71-2.12 2.12a37.82 37.82 0 0 0 3 2.67l1.88-2.34a33.7 33.7 0 0 1-2.74-2.45zm5.72 4.59-1.61 2.53c0.38 0.25 0.78 0.49 1.17 0.72l0.1 0.06h0.34c0.59 0.33 1.19 0.65 1.79 1l1.34-2.68a36.08 36.08 0 0 1-3.2-1.82zm6.57 3.28-1 2.81 0.91 0.32h1.29c0.52 0.15 1.05 0.3 1.57 0.43l0.73-2.91a36.42 36.42 0 0 1-3.51-1.08zm7.12 1.78-0.41 3a37.85 37.85 0 0 0 3.87 0.34h0.11l0.1-3a34.49 34.49 0 0 1-3.67-0.32zm11-0.23a34.36 34.36 0 0 1-3.65 0.47l0.22 3a37.12 37.12 0 0 0 4-0.51l-0.54-2.95zm7-2.09a35.63 35.63 0 0 1-3.46 1.24l0.85 2.87c0.65-0.19 1.3-0.4 1.93-0.63h1.7l-1.16-2.77zm6.43-3.55a32.52 32.52 0 0 1-3.12 1.95l1.45 2.63c0.66-0.37 1.31-0.75 1.95-1.16h0.33l0.09-0.06 1-0.65-1.72-2.46zm5.53-4.83a33.55 33.55 0 0 1-2.64 2.56l2 2.26c0.46-0.41 0.92-0.82 1.36-1.25h0.14c0.47-0.45 0.92-0.92 1.36-1.4l-2.2-2zm4.38-5.9a35.43 35.43 0 0 1-2 3.07l2.4 1.79c0.58-0.78 1.13-1.58 1.65-2.41h0.05c0.15-0.24 0.31-0.49 0.45-0.75l-2.58-1.52zm3-6.69a34.74 34.74 0 0 1-1.33 3.43l2.73 1.24a37.38 37.38 0 0 0 1.45-3.73zm1.52-7.18a32 32 0 0 1-0.57 3.64l2.94 0.62v-0.08c0.09-0.44 0.17-0.89 0.25-1.33v-0.15c0.09-0.6 0.16-1.2 0.22-1.81l-3-0.31zm2.94-7.68-3 0.33a34.62 34.62 0 0 1 0.22 3.68h3v-1.57c0-0.35-0.07-0.69-0.11-1zm-1.73-7.79-2.84 1a33.15 33.15 0 0 1 1 3.54l2.97-0.7c0-0.17-0.08-0.34-0.11-0.5v-0.06c-0.26-1.06-0.57-2.11-0.92-3.14zm-3.36-7.25-2.51 1.55a36.09 36.09 0 0 1 1.73 3.25l2.72-1.27a36.14 36.14 0 0 0-1.88-3.53zm-4.82-6.36-2.19 2.06a33.64 33.64 0 0 1 2.38 2.81l2.39-1.82-0.33-0.42h-0.15l-0.65-0.79-0.08-0.1-0.06-0.07h-0.14l-0.87-0.95zm-6.07-5.19-1.62 2.47a34.64 34.64 0 0 1 2.91 2.24l2-2.28a37.46 37.46 0 0 0-3.17-2.43zm-7-3.79-1.14 2.77c1.13 0.47 2.25 1 3.33 1.57l1.42-2.64-0.17-0.09h-0.39c-1-0.5-2-1-3-1.38zm-7.68-2.2-0.51 3a33.69 33.69 0 0 1 3.58 0.81l0.83-2.88a39.35 39.35 0 0 0-3.9-0.89zm-6.39-0.55v3c0.74 0 1.49 0 2.23 0.08l0.19-3c-0.62 0-1.25-0.06-1.88-0.07h-0.54z"
            />
            <path
              class="cls-33"
              d="m235.54 276.38a5.64 5.64 0 0 0 4.88-2.46c1.81-2.52 2.9-7.18 2.92-12.45s-1.05-10.23-2.8-12.91a25.47 25.47 0 0 0-1.87-2.58l-0.07-0.08v-0.11a19.36 19.36 0 0 1-0.22-3.66 9 9 0 0 1 0.58-3.11c0.26-0.61 0.57-1.15 1.46-1.15h0.1l7.81 0.33 0.07-7.46c-0.69-0.11-1.46-0.18-2.28-0.26a18.08 18.08 0 0 1-5.38-1l-0.12-0.06-0.06-0.12a4.26 4.26 0 0 1-0.53-3 0.92 0.92 0 0 1 0.52-0.57 9.05 9.05 0 0 1 3.06-0.32c1.57 0 3.38 0.1 4.58 0.17h0.06v-2.16c0-1.67 0-3.33 0.06-5h-0.31c-7.67 0-18.27 1.1-25.22 6.38l-0.42 0.32-0.16-0.5c-1.11-3.41-3.67-11.26-4.09-12.35l-0.23-0.59h-0.63c-0.63 0-1.22 0.09-1.8 0.15-0.76 0.07-1.55 0.15-2.39 0.16 0.85 8.94 0.92 14.94-4.26 22a20 20 0 0 0-3.24 5.54c-1 3.39-0.32 7.68 0.28 11.47v0.08c0.1 0.62 0.2 1.23 0.3 2a4.61 4.61 0 0 0 1 1.86 5 5 0 0 1 0.91 1.65c0.51 2.55 2.3 5.37 5.18 8.15a36 36 0 0 0 10.26 6.9c0.45 0.19 1.17 0.58 2 1l0.08 0.05c3.1 1.69 6.73 3.7 10 3.65z"
            />
            <path
              class="cls-34"
              d="m211.26 258.28c-0.54-1.83 3.06-2.49 7.23-2s3.06-11 9.42 4.32c3.55 8.53 11.32 15.42 5.35 13.52-6.47-2.04-19.79-8.48-22-15.84z"
            />
            <path
              class="cls-35"
              d="m235.46 246.23c-1.45-1.22-2 4.38-7.89 5.13-4.16 0.53 9.54 26.26 11.51 20.31 2.92-8.91 2.23-20.52-3.62-25.44z"
            />
            <path
              class="cls-34"
              d="m210.37 250.27c0.43-3.82 5-8.88 7.69-6.14 3.15 3.2 4.17 10.67 0.34 10.37-4.4-0.33-8.4-0.41-8.03-4.23z"
            />
            <path
              class="cls-36"
              d="m229.06 248.7c3.22-1.44 7.59-6.87 3.76-7-5.61-0.15-10.38-2.1-9.5 0.87s2.92 7.43 5.74 6.13z"
            />
          </g>
          <g id="gedi-ok">
            <circle
              class="cls-40"
              transform="rotate(-80.78 227.6 243.13)"
              cx="227.58"
              cy="243.13"
              r="45.96"
            /> <circle class="cls-41" cx="227.58" cy="243.13" r="37.3" />
            <path
              class="cls-33"
              d="m235.54 276.38a5.64 5.64 0 0 0 4.88-2.46c1.81-2.52 2.9-7.18 2.92-12.45s-1.05-10.23-2.8-12.91a25.47 25.47 0 0 0-1.87-2.58l-0.07-0.08v-0.11a19.36 19.36 0 0 1-0.22-3.66 9 9 0 0 1 0.58-3.11c0.26-0.61 0.57-1.15 1.46-1.15h0.1l7.81 0.33 0.07-7.46c-0.69-0.11-1.46-0.18-2.28-0.26a18.08 18.08 0 0 1-5.38-1l-0.12-0.06-0.06-0.12a4.26 4.26 0 0 1-0.53-3 0.92 0.92 0 0 1 0.52-0.57 9.05 9.05 0 0 1 3.06-0.32c1.57 0 3.38 0.1 4.58 0.17h0.06v-2.16c0-1.67 0-3.33 0.06-5h-0.31c-7.67 0-18.27 1.1-25.22 6.38l-0.42 0.32-0.16-0.5c-1.11-3.41-3.67-11.26-4.09-12.35l-0.23-0.59h-0.63c-0.63 0-1.22 0.09-1.8 0.15-0.76 0.07-1.55 0.15-2.39 0.16 0.85 8.94 0.92 14.94-4.26 22a20 20 0 0 0-3.24 5.54c-1 3.39-0.32 7.68 0.28 11.47v0.08c0.1 0.62 0.2 1.23 0.3 2a4.61 4.61 0 0 0 1 1.86 5 5 0 0 1 0.91 1.65c0.51 2.55 2.3 5.37 5.18 8.15a36 36 0 0 0 10.26 6.9c0.45 0.19 1.17 0.58 2 1l0.08 0.05c3.1 1.69 6.73 3.7 10 3.65z"
            />
            <path
              class="cls-34"
              d="m211.26 258.28c-0.54-1.83 3.06-2.49 7.23-2s3.06-11 9.42 4.32c3.55 8.53 11.32 15.42 5.35 13.52-6.47-2.04-19.79-8.48-22-15.84z"
            />
            <path
              class="cls-35"
              d="m235.46 246.23c-1.45-1.22-2 4.38-7.89 5.13-4.16 0.53 9.54 26.26 11.51 20.31 2.92-8.91 2.23-20.52-3.62-25.44z"
            />
            <path
              class="cls-34"
              d="m210.37 250.27c0.43-3.82 5-8.88 7.69-6.14 3.15 3.2 4.17 10.67 0.34 10.37-4.4-0.33-8.4-0.41-8.03-4.23z"
            />
            <path
              class="cls-36"
              d="m229.06 248.7c3.22-1.44 7.59-6.87 3.76-7-5.61-0.15-10.38-2.1-9.5 0.87s2.92 7.43 5.74 6.13z"
            />
          </g>
          <g id="gedi-low">
            <circle
              class="cls-32"
              transform="rotate(-80.78 227.6 243.13)"
              cx="227.58"
              cy="243.13"
              r="45.96"
            />
            <path
              class="cls-42"
              d="m227.58 208.82a34.31 34.31 0 1 1-34.3 34.31 34.35 34.35 0 0 1 34.3-34.31m0-3a37.31 37.31 0 1 0 37.31 37.31 37.31 37.31 0 0 0-37.31-37.31z"
            />
            <path
              class="cls-33"
              d="m235.54 276.38a5.64 5.64 0 0 0 4.88-2.46c1.81-2.52 2.9-7.18 2.92-12.45s-1.05-10.23-2.8-12.91a25.47 25.47 0 0 0-1.87-2.58l-0.07-0.08v-0.11a19.36 19.36 0 0 1-0.22-3.66 9 9 0 0 1 0.58-3.11c0.26-0.61 0.57-1.15 1.46-1.15h0.1l7.81 0.33 0.07-7.46c-0.69-0.11-1.46-0.18-2.28-0.26a18.08 18.08 0 0 1-5.38-1l-0.12-0.06-0.06-0.12a4.26 4.26 0 0 1-0.53-3 0.92 0.92 0 0 1 0.52-0.57 9.05 9.05 0 0 1 3.06-0.32c1.57 0 3.38 0.1 4.58 0.17h0.06v-2.16c0-1.67 0-3.33 0.06-5h-0.31c-7.67 0-18.27 1.1-25.22 6.38l-0.42 0.32-0.16-0.5c-1.11-3.41-3.67-11.26-4.09-12.35l-0.23-0.59h-0.63c-0.63 0-1.22 0.09-1.8 0.15-0.76 0.07-1.55 0.15-2.39 0.16 0.85 8.94 0.92 14.94-4.26 22a20 20 0 0 0-3.24 5.54c-1 3.39-0.32 7.68 0.28 11.47v0.08c0.1 0.62 0.2 1.23 0.3 2a4.61 4.61 0 0 0 1 1.86 5 5 0 0 1 0.91 1.65c0.51 2.55 2.3 5.37 5.18 8.15a36 36 0 0 0 10.26 6.9c0.45 0.19 1.17 0.58 2 1l0.08 0.05c3.1 1.69 6.73 3.7 10 3.65z"
            />
            <path
              class="cls-34"
              d="m211.26 258.28c-0.54-1.83 3.06-2.49 7.23-2s3.06-11 9.42 4.32c3.55 8.53 11.32 15.42 5.35 13.52-6.47-2.04-19.79-8.48-22-15.84z"
            />
            <path
              class="cls-35"
              d="m235.46 246.23c-1.45-1.22-2 4.38-7.89 5.13-4.16 0.53 9.54 26.26 11.51 20.31 2.92-8.91 2.23-20.52-3.62-25.44z"
            />
            <path
              class="cls-34"
              d="m210.37 250.27c0.43-3.82 5-8.88 7.69-6.14 3.15 3.2 4.17 10.67 0.34 10.37-4.4-0.33-8.4-0.41-8.03-4.23z"
            />
            <path
              class="cls-36"
              d="m229.06 248.7c3.22-1.44 7.59-6.87 3.76-7-5.61-0.15-10.38-2.1-9.5 0.87s2.92 7.43 5.74 6.13z"
            />
          </g>
          <g id="gedi-verylow">
            <circle
              class="cls-32"
              transform="rotate(-80.78 227.6 243.13)"
              cx="227.58"
              cy="243.13"
              r="45.96"
            />
            <path
              class="cls-43"
              d="m227.58 208.82a34.31 34.31 0 1 1-34.3 34.31 34.35 34.35 0 0 1 34.3-34.31m0-3a37.31 37.31 0 1 0 37.31 37.31 37.31 37.31 0 0 0-37.31-37.31z"
            />
            <path
              class="cls-33"
              d="m235.54 276.38a5.64 5.64 0 0 0 4.88-2.46c1.81-2.52 2.9-7.18 2.92-12.45s-1.05-10.23-2.8-12.91a25.47 25.47 0 0 0-1.87-2.58l-0.07-0.08v-0.11a19.36 19.36 0 0 1-0.22-3.66 9 9 0 0 1 0.58-3.11c0.26-0.61 0.57-1.15 1.46-1.15h0.1l7.81 0.33 0.07-7.46c-0.69-0.11-1.46-0.18-2.28-0.26a18.08 18.08 0 0 1-5.38-1l-0.12-0.06-0.06-0.12a4.26 4.26 0 0 1-0.53-3 0.92 0.92 0 0 1 0.52-0.57 9.05 9.05 0 0 1 3.06-0.32c1.57 0 3.38 0.1 4.58 0.17h0.06v-2.16c0-1.67 0-3.33 0.06-5h-0.31c-7.67 0-18.27 1.1-25.22 6.38l-0.42 0.32-0.16-0.5c-1.11-3.41-3.67-11.26-4.09-12.35l-0.23-0.59h-0.63c-0.63 0-1.22 0.09-1.8 0.15-0.76 0.07-1.55 0.15-2.39 0.16 0.85 8.94 0.92 14.94-4.26 22a20 20 0 0 0-3.24 5.54c-1 3.39-0.32 7.68 0.28 11.47v0.08c0.1 0.62 0.2 1.23 0.3 2a4.61 4.61 0 0 0 1 1.86 5 5 0 0 1 0.91 1.65c0.51 2.55 2.3 5.37 5.18 8.15a36 36 0 0 0 10.26 6.9c0.45 0.19 1.17 0.58 2 1l0.08 0.05c3.1 1.69 6.73 3.7 10 3.65z"
            />
            <path
              class="cls-34"
              d="m211.26 258.28c-0.54-1.83 3.06-2.49 7.23-2s3.06-11 9.42 4.32c3.55 8.53 11.32 15.42 5.35 13.52-6.47-2.04-19.79-8.48-22-15.84z"
            />
            <path
              class="cls-35"
              d="m235.46 246.23c-1.45-1.22-2 4.38-7.89 5.13-4.16 0.53 9.54 26.26 11.51 20.31 2.92-8.91 2.23-20.52-3.62-25.44z"
            />
            <path
              class="cls-34"
              d="m210.37 250.27c0.43-3.82 5-8.88 7.69-6.14 3.15 3.2 4.17 10.67 0.34 10.37-4.4-0.33-8.4-0.41-8.03-4.23z"
            />
            <path
              class="cls-36"
              d="m229.06 248.7c3.22-1.44 7.59-6.87 3.76-7-5.61-0.15-10.38-2.1-9.5 0.87s2.92 7.43 5.74 6.13z"
            />
          </g>
        </g>
        <g id="svri-states">
          <g id="svri-inactive" class="cls-44">
            <g class="cls-45" clip-path="url(#clip-path-8)">
              <polygon
                class="cls-46"
                points="228.61 371.78 189.81 371.73 189.66 385.64 228.61 385.64 267.94 385.64 268.25 371.78"
                style="fill:url(#Unbenannter_Verlauf_2-2)"
              />
            </g>
            <path
              class="cls-38"
              d="m229 340.12h-0.87c-1.05 0-2.09 0.09-3.12 0.19l0.2 2a36.85 36.85 0 0 1 3.79-0.19zm-7.94 0.82-0.85 0.18h-0.46l-1.38 0.36h-0.38l-0.8 0.25 0.62 1.91a32.85 32.85 0 0 1 3.66-1l-0.41-2zm-7.6 2.44-0.23 0.11h-0.61l-0.14 0.07h-0.07l-0.13 0.06-0.28 0.38h-0.05l-0.13 0.06h-0.08l-0.09 0.05h-0.65l-0.13 0.07c-0.33 0.18-0.65 0.35-1 0.54l1 1.73c1.1-0.62 2.23-1.2 3.38-1.71l-0.8-1.83zm-6.93 4-0.65 0.47-0.09 0.07h-0.21q-1.1 0.85-2.13 1.77l1.33 1.5a35.16 35.16 0 0 1 2.95-2.37l-1.16-1.63zm-6 5.31c-0.7 0.77-1.37 1.57-2 2.39l-0.05 0.06h-0.27l-0.06 0.08v0.06l1.61 1.19a37.49 37.49 0 0 1 2.24-2.47l-1.48-1.35zm-4.75 6.42c-0.38 0.64-0.74 1.3-1.08 2v0.08h-0.16v0.09l-0.45 0.95 1.82 0.83a34.5 34.5 0 0 1 1.75-3.36l-1.72-1zm-3.32 7.26v0.24c-0.31 1-0.59 2-0.82 3.09l1.95 0.43a35.24 35.24 0 0 1 1-3.65l-1.9-0.64zm-1.74 7.8c0 0.35-0.08 0.71-0.11 1.07-0.07 0.86-0.11 1.72-0.12 2.6h2a36.72 36.72 0 0 1 0.25-3.78l-2-0.23zm1.89 7.8-2 0.18a39.72 39.72 0 0 0 0.56 4l2-0.38a36.57 36.57 0 0 1-0.53-3.76zm1.46 7.43-1.92 0.59c0.4 1.28 0.86 2.54 1.38 3.76l1.84-0.79a34.41 34.41 0 0 1-1.3-3.56zm3 7-1.75 1c0.48 0.85 1 1.67 1.51 2.48v0.06h0.24l0.06 0.1 0.18 0.25 1.63-1.15a36.7 36.7 0 0 1-2-3.21zm4.35 6.2-1.51 1.31a35.84 35.84 0 0 0 2.77 2.88l1.36-1.46a37.53 37.53 0 0 1-2.62-2.73zm5.52 5.18-1.21 1.59c0.57 0.43 1.15 0.85 1.75 1.25h0.23l0.09 0.06c0.39 0.26 0.79 0.52 1.2 0.76l1-1.71a36.69 36.69 0 0 1-3.13-2.13zm6.47 3.93-0.85 1.81a39.7 39.7 0 0 0 3.69 1.52l0.67-1.89a36.93 36.93 0 0 1-3.51-1.44zm7.14 2.51-0.55 1.88a36.75 36.75 0 0 0 3.93 0.72l0.26-2a36.47 36.47 0 0 1-3.73-0.68zm11.3 0.87c-0.94 0.07-1.89 0.11-2.84 0.11h-1.01l-0.05 2h1.85l1.4-0.05h0.8l-0.16-2zm7.45-1.36a36 36 0 0 1-3.69 0.88l0.36 2 0.93-0.18h0.42c0.86-0.19 1.7-0.4 2.54-0.65l-0.56-1.92zm7-2.87c-1.11 0.59-2.26 1.14-3.42 1.62l0.76 1.85c1-0.41 2-0.86 2.91-1.34h0.1l0.6-0.31-0.95-1.76zm6.26-4.27a35.35 35.35 0 0 1-3 2.3l1.13 1.65a39.17 39.17 0 0 0 3.18-2.42l-1.29-1.53zm5.25-5.45a37.35 37.35 0 0 1-2.48 2.86l1.44 1.39 0.17-0.18h0.1l0.09-0.09c0.34-0.37 0.67-0.74 1-1.12l0.09-0.11h0.18v-0.05c0.3-0.35 0.58-0.7 0.87-1.06l-1.58-1.23zm4-6.42c-0.56 1.13-1.18 2.24-1.84 3.31l1.69 1.06c0.39-0.63 0.77-1.27 1.12-1.92l0.06-0.12h0.16v-0.14c0.18-0.33 0.35-0.67 0.51-1l-1.79-0.88zm2.6-7.11a37.87 37.87 0 0 1-1.12 3.62l1.88 0.69a38.37 38.37 0 0 0 1.18-3.82zm1.07-7.5c-0.05 1.27-0.17 2.54-0.34 3.78l2 0.28v-0.06c0.14-1 0.23-2 0.29-3v-0.54l-2-0.08zm1.48-7.89-2 0.33a36.56 36.56 0 0 1 0.44 3.77l2-0.13c-0.09-1.29-0.24-2.55-0.45-3.8zm-2.14-7.69-1.86 0.73a35.33 35.33 0 0 1 1.2 3.6l1.93-0.54c-0.36-1.29-0.79-2.56-1.27-3.79zm-3.7-7.08-1.67 1.1a34.62 34.62 0 0 1 1.93 3.27l1.77-0.93c-0.09-0.19-0.19-0.37-0.29-0.56l-0.06-0.1h-0.19c-0.33-0.57-0.67-1.14-1-1.69h-0.08v-0.05l-0.25-0.38zm-5.12-6.23-1.41 1.43a34 34 0 0 1 2.56 2.8l1.54-1.27h-0.07v-0.05h-0.3l-0.05-0.05h-0.06l-0.07-0.07h-0.14l-0.06-0.08h-0.05l-0.09-0.11c-0.58-0.65-1.17-1.27-1.78-1.88zm-6.23-5-1.09 1.68a37.48 37.48 0 0 1 3.08 2.21l1.25-1.56-0.34-0.27h-0.37l-0.09-0.06c-0.78-0.59-1.57-1.14-2.39-1.67zm-7.13-3.61-0.71 1.87a36.81 36.81 0 0 1 3.47 1.52l0.91-1.79-0.16-0.08h-0.48c-0.81-0.39-1.63-0.76-2.47-1.09h-0.29l-0.26-0.11zm-7.72-2-0.31 2a35.37 35.37 0 0 1 3.71 0.77l0.51-1.93c-0.7-0.19-1.41-0.35-2.13-0.5h-0.45l-1.33-0.23zm-6-0.46v2c0.63 0 1.27 0 1.9 0.05l0.1-2h-1.92z"
            />
          </g>
          <g id="svri-veryhigh">
            <use
              transform="matrix(.88 0 0 .88 184.28 340.12)"
              width="102.07"
              height="88"
              xlink:href="#Gef%C3%A4%C3%9F_verengt"
            />
            <path
              class="cls-43"
              d="m229 342.12a36.51 36.51 0 1 1-36.51 36.51 36.55 36.55 0 0 1 36.51-36.51m0-2a38.51 38.51 0 1 0 38.51 38.51 38.51 38.51 0 0 0-38.51-38.51z"
            />
          </g>
          <g id="svri-high">
            <use
              transform="matrix(.88 0 0 .88 184.28 340.12)"
              width="102.07"
              height="88"
              xlink:href="#Gef%C3%A4%C3%9F_verengt"
            />
            <path
              class="cls-14"
              d="m229 342.12a36.51 36.51 0 1 1-36.51 36.51 36.55 36.55 0 0 1 36.51-36.51m0-2a38.51 38.51 0 1 0 38.51 38.51 38.51 38.51 0 0 0-38.51-38.51z"
            />
          </g>
          <g id="svri-ok">
            <g class="cls-45" clip-path="url(#clip-path-8)">
              <polygon
                class="cls-46"
                points="228.61 371.78 189.81 371.73 189.66 385.64 228.61 385.64 267.94 385.64 268.25 371.78"
                style="fill:url(#Unbenannter_Verlauf_2-2)"
              />
            </g>
            <path
              class="cls-47"
              d="m229 342.12a36.51 36.51 0 1 1-36.51 36.51 36.55 36.55 0 0 1 36.51-36.51m0-2a38.51 38.51 0 1 0 38.51 38.51 38.51 38.51 0 0 0-38.51-38.51z"
            />
          </g>
          <g id="svri-low">
            <g class="cls-48" clip-path="url(#clip-path-10)">
              <path
                class="cls-49"
                d="m186.72 371.63-0.16 15.08h10.78a20.85 20.85 0 0 1 11.53 3.48l8.68 5.76a20.85 20.85 0 0 0 22.63 0.29l10.1-6.34a20.88 20.88 0 0 1 11.08-3.19h10l0.34-15h-10.34a20.85 20.85 0 0 1-11.09-3.19l-10.11-6.34a20.84 20.84 0 0 0-22.6 0.27l-8.68 5.75a20.88 20.88 0 0 1-11.55 3.47z"
                style="fill:url(#Unbenannter_Verlauf_2-4)"
              />
            </g>
            <path
              class="cls-14"
              d="m229 342.12a36.51 36.51 0 1 1-36.51 36.51 36.55 36.55 0 0 1 36.51-36.51m0-2a38.51 38.51 0 1 0 38.51 38.51 38.51 38.51 0 0 0-38.51-38.51z"
            />
          </g>
          <g id="svri-verylow">
            <g class="cls-48" clip-path="url(#clip-path-10)">
              <path
                class="cls-49"
                d="m186.72 371.63-0.16 15.08h10.78a20.85 20.85 0 0 1 11.53 3.48l8.68 5.76a20.85 20.85 0 0 0 22.63 0.29l10.1-6.34a20.88 20.88 0 0 1 11.08-3.19h10l0.34-15h-10.34a20.85 20.85 0 0 1-11.09-3.19l-10.11-6.34a20.84 20.84 0 0 0-22.6 0.27l-8.68 5.75a20.88 20.88 0 0 1-11.55 3.47z"
                style="fill:url(#Unbenannter_Verlauf_2-4)"
              />
            </g>
            <path
              class="cls-43"
              d="m229 342.12a36.51 36.51 0 1 1-36.51 36.51 36.55 36.55 0 0 1 36.51-36.51m0-2a38.51 38.51 0 1 0 38.51 38.51 38.51 38.51 0 0 0-38.51-38.51z"
            />
          </g>
        </g>
      </g>
      <style>
        @font-face {
          font-family: 'TrebuchetFlex';
          src: url('/assets/font/TREBUCFLX.TTF');
        }
        .traffic-container {
        }
        .cls-1,
        .cls-13,
        .cls-18,
        .cls-19,
        .cls-21,
        .cls-22,
        .cls-23,
        .cls-24,
        .cls-25,
        .cls-32,
        .cls-33,
        .cls-37,
        .cls-39,
        .cls-40,
        .cls-41 {
          fill: none;
        }
        .cls-2 {
          stroke: #000;
          fill: url(#Unbenannter_Verlauf_13);
        }
        .cls-13,
        .cls-18,
        .cls-19,
        .cls-2,
        .cls-21,
        .cls-22,
        .cls-23,
        .cls-24,
        .cls-25,
        .cls-32,
        .cls-33,
        .cls-37,
        .cls-39,
        .cls-40,
        .cls-5 {
          stroke-miterlimit: 10;
        }
        .cls-3 {
          clip-path: url(#clip-path);
        }
        .cls-4 {
          fill: url(#Unbenannter_Verlauf_2);
        }
        .cls-5 {
          fill: #141414;
          stroke: url(#Unbenannter_Verlauf_39);
        }
        .cls-6 {
          fill: url(#Unbenannter_Verlauf_18);
        }
        .cls-7 {
          fill: url(#Unbenannter_Verlauf_7);
        }
        .cls-8 {
          fill: #ed1c24;
        }
        .cls-9 {
          fill: #29abe2;
        }
        .cls-10 {
          font-size: 21px;
        }
        .cls-10,
        .cls-20 {
          fill: #f2f2f2;
        }
        .cls-10,
        .cls-16 {
          font-family: TrebuchetFlex, TrebuchetFlex;
        }
        .cls-11 {
          letter-spacing: -0.13em;
        }
        .cls-12 {
          font-size: 12px;
        }
        .cls-13,
        .cls-21,
        .cls-32,
        .cls-33 {
          stroke: gray;
        }
        .cls-14 {
          fill: #ff0;
        }
        .cls-15 {
          fill: #d9e021;
        }
        .cls-16 {
          font-size: 20.77px;
          fill: #e6e6e6;
        }
        .cls-17 {
          letter-spacing: -0.05em;
        }
        .cls-18,
        .cls-25 {
          stroke: #999;
        }
        .cls-18,
        .cls-19 {
          opacity: 0.8;
        }
        .cls-19 {
          stroke: #f2f2f2;
        }
        .cls-21,
        .cls-22,
        .cls-23,
        .cls-24,
        .cls-25 {
          stroke-linecap: round;
          stroke-width: 5.13px;
        }
        .cls-21,
        .cls-27,
        .cls-31 {
          opacity: 0.2;
        }
        .cls-22,
        .cls-37 {
          stroke: red;
        }
        .cls-22,
        .cls-23 {
          stroke-dasharray: 8;
        }
        .cls-23,
        .cls-39 {
          stroke: #fcee21;
        }
        .cls-24,
        .cls-40 {
          stroke: #39b54a;
        }
        .cls-26 {
          clip-path: url(#clip-path-2);
        }
        .cls-27,
        .cls-38 {
          fill: gray;
        }
        .cls-28 {
          clip-path: url(#clip-path-3);
        }
        .cls-29 {
          clip-path: url(#clip-path-4);
        }
        .cls-30 {
          fill: #999;
        }
        .cls-32,
        .cls-37,
        .cls-39,
        .cls-40 {
          stroke-width: 2px;
        }
        .cls-32,
        .cls-40 {
          stroke-dasharray: 4.01 4.01;
        }
        .cls-33 {
          stroke-width: 2.43px;
        }
        .cls-33,
        .cls-34,
        .cls-35,
        .cls-36 {
          fill-rule: evenodd;
        }
        .cls-34 {
          fill: blue;
        }
        .cls-35,
        .cls-43 {
          fill: red;
        }
        .cls-36 {
          fill: #ff2626;
        }
        .cls-41 {
          opacity: 0.15;
        }
        .cls-42 {
          fill: #fcee21;
        }
        .cls-44 {
          opacity: 0.25;
        }
        .cls-45 {
          clip-path: url(#clip-path-8);
        }
        .cls-46 {
          fill: url(#Unbenannter_Verlauf_2-2);
        }
        .cls-47 {
          fill: #39b54a;
        }
        .cls-48 {
          clip-path: url(#clip-path-10);
        }
        .cls-49 {
          fill: url(#Unbenannter_Verlauf_2-4);
        }
      </style>
      <clipPath id="clip-path"> <circle class="cls-1" cx="51.04" cy="44" r="44" /> </clipPath>
      <linearGradient
        id="Unbenannter_Verlauf_2"
        x2="102.07"
        y1="44"
        y2="44"
        data-name="Unbenannter Verlauf 2"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="blue" offset=".33" /> <stop stop-color="red" offset=".75" />
      </linearGradient>
      <linearGradient
        id="Unbenannter_Verlauf_7"
        x1="155.01"
        x2="302.06"
        y1="175.78"
        y2="175.78"
        data-name="Unbenannter Verlauf 7"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#29abe2" offset="0" /> <stop stop-color="#ed1c24" offset="1" />
      </linearGradient>
      <clipPath id="clip-path-2">
        <rect class="cls-1" x="173.42" y="103.84" width="113.52" height="84.48" />
      </clipPath>
      <clipPath id="clip-path-3">
        <rect class="cls-1" x="173.42" y="56.84" width="113.52" height="84.48" />
      </clipPath>
      <clipPath id="clip-path-4">
        <rect class="cls-1" x="173.42" y="77.84" width="113.52" height="84.48" />
      </clipPath>
      <clipPath id="clip-path-8">
        <circle class="cls-1" cx="228.95" cy="379.01" r="37.94" />
      </clipPath>
      <linearGradient
        id="Unbenannter_Verlauf_2-2"
        x1="189.66"
        x2="268.25"
        y1="378.68"
        y2="378.68"
        xlink:href="#Unbenannter_Verlauf_2"
      />
      <clipPath id="clip-path-10">
        <circle class="cls-1" cx="229.14" cy="379.2" r="38.13" />
      </clipPath>
      <linearGradient
        id="Unbenannter_Verlauf_2-4"
        x1="186.56"
        x2="271.72"
        y1="379.2"
        y2="379.2"
        xlink:href="#Unbenannter_Verlauf_2"
      />
      <symbol id="Gefäß_verengt" data-name="Gefäß verengt" viewBox="0 0 102.07 88">
        <g class="cls-3" clip-path="url(#clip-path)">
          <path
            class="cls-4"
            d="m0.19 35-0.19 18h12.38a49.9 49.9 0 0 0 15.75-2.55l7.15-2.37a50 50 0 0 1 30.72-0.21l9.16 2.87a50.08 50.08 0 0 0 15 2.3h11.55l0.4-18h-11.99a50 50 0 0 0-15 2.29l-9.12 2.86a50 50 0 0 1-30.78-0.27l-7.13-2.37a50 50 0 0 0-15.7-2.55z"
          />
        </g>
      </symbol>
      <linearGradient
        id="linearGradient17481"
        x1="13.003"
        x2="1.94"
        y1="15.082"
        y2=".92"
        gradientTransform="matrix(.070004 0 0 .070004 .17851 .22831)"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="lime" style="stop-color:#a1a1a1" offset=".02" />
        <stop stop-color="#04ff04" style="stop-color:#a1a1a1" offset=".13" />
        <stop stop-color="#1f1" style="stop-color:#a1a1a1" offset=".25" />
        <stop stop-color="#27ff27" style="stop-color:#a1a1a1" offset=".37" />
        <stop stop-color="#45ff45" style="stop-color:#a2a2a2" offset=".49" />
        <stop stop-color="#6bff6b" style="stop-color:#a1a1a1" offset=".62" />
        <stop stop-color="#9bff9b" style="stop-color:#a1a1a1" offset=".69184" />
        <stop stop-color="#d2ffd2" style="stop-color:#a1a1a1" offset=".81231" />
        <stop stop-color="#fff" offset=".97" />
      </linearGradient>
      <linearGradient
        id="linearGradient17618"
        x1="9.47"
        x2="1.94"
        y1="10.33"
        y2=".92"
        gradientTransform="matrix(.070004 0 0 .070004 .17851 .22831)"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="lime" offset=".02" /> <stop stop-color="#04ff04" offset=".13" />
        <stop stop-color="#1f1" offset=".25" /> <stop stop-color="#27ff27" offset=".37" />
        <stop stop-color="#45ff45" offset=".49" /> <stop stop-color="#6bff6b" offset=".62" />
        <stop stop-color="#9bff9b" offset=".75" /> <stop stop-color="#d2ffd2" offset=".87" />
        <stop stop-color="#fff" offset=".97" />
      </linearGradient>
    </defs>
    <g>
      <g transform="translate(121.62 10.312)">
        <g transform="translate(-120.61,-11.975)">
          <use
            id="pvpi-container"
            width="100%"
            height="100%"
            xlink:href="#pvpi-{pvpi_range}"
          /><!-- DATA statecontainers value reference in id-->
          <use
            id="elwi-container"
            width="100%"
            height="100%"
            xlink:href="#elwi-{elwi_range}"
          /><!-- DATA statecontainers value reference in id-->
          <use
            id="gedi-container"
            width="100%"
            height="100%"
            xlink:href="#gedi-{gedi_range}"
          /><!-- DATA statecontainers value reference in id-->
          <use
            id="svri-container"
            width="100%"
            height="100%"
            xlink:href="#svri-{svri_range}"
          /><!-- DATA statecontainers value reference in id-->
        </g>
        <g transform="translate(-121,-11.285)">
          <path class="cls-13" d="m122.19 78.434h107.09" style="fill:none;stroke-miterlimit:10" />
          <path
            class="cls-7"
            d="m165 240.37h14.4a47.87 47.87 0 0 1 0.73-5.92h-15.13a4 4 0 0 1-4-3.95v-109.45a4 4 0 0 1 4-4h9.31c4.79 4.87 26.84 25.7 53.59 25.7s50.88-21 55.86-25.7h8.35a3 3 0 0 1 3 2.94l0.94 110.42a3.93 3.93 0 0 1-1.16 2.82 4 4 0 0 1-2.84 1.17h-16.05a47.87 47.87 0 0 1 0.73 5.92h15.37a10 10 0 0 0 7.1-2.92 9.75 9.75 0 0 0 2.9-7l-0.98-110.4a9 9 0 0 0-9-8.81h-10.8l-0.88 0.87c-0.25 0.25-25.45 24.82-52.53 24.82s-49.85-24.48-50.08-24.72l-0.89-1h-11.94a9.94 9.94 0 0 0-10 9.87v109.47a9.94 9.94 0 0 0 10 9.87z"
            style="fill:url(#Unbenannter_Verlauf_7)"
          />
          <path
            class="cls-8"
            d="m292.69 247.16h-16.09a46.11 46.11 0 0 1-0.85 5.92h16.94a3 3 0 0 1 3 3v116.45a3 3 0 0 1-3 3h-21.56c0.07 1 0.12 2 0.12 3s-0.05 2-0.12 3h21.56a9 9 0 0 0 9-8.89v-116.59a9 9 0 0 0-9-8.89z"
          />
          <path
            class="cls-9"
            d="m185.82 378.46c0-1 0.05-2 0.12-3h-21.57a3 3 0 0 1-3-3v-116.41a3 3 0 0 1 3-3h16a46.11 46.11 0 0 1-0.85-5.92h-15.15a9 9 0 0 0-9 8.89v116.51a9 9 0 0 0 9 8.89h21.57c-0.07-0.98-0.12-1.96-0.12-2.96z"
          />
          <path class="cls-13" d="m122.18 107.22h64s17 21.94 44.34 21.94 42.48-21.94 42.48-21.94" />
          <polyline class="cls-13" points="121 217.06 134.27 217.06 134.27 230.98 231.36 230.98" />
          <line class="cls-13" x1="121" x2="190.5" y1="244.78" y2="244.78" />
          <polyline class="cls-13" points="121 299.83 134.4 299.83 134.4 258.44 217.04 258.44" />
          <line class="cls-13" x1="134.4" x2="121" y1="271.58" y2="271.58" /><path
            class="cls-33"
            d="m261.14 400.89h74.159"
            style="fill:none;stroke-width:.65321px"
          />
        </g>
        <g style="display:none">
          <g id="indicator-veryhigh" transform="translate(2.1766,-36.888)" style="display:inline">
            <polygon
              class="cls-14"
              transform="matrix(-.04603 -.04603 .04603 -.04603 -5.7232 43.229)"
              points="14.77 96.7 23.77 113.98 6.66 104.85 13.29 103.41"
              style="fill:#ff0000"
            />
            <path
              class="cls-15"
              transform="matrix(-.04603 -.04603 .04603 -.04603 -5.7232 43.229)"
              d="m14.77 96.7-1.48 6.71 10.48 10.57z"
              style="fill:#df2020"
            />
          </g>
          <g id="indicator-inactive" transform="translate(-.0017504 -.045599)">
            <circle
              class="cls-6"
              cx=".60064"
              cy=".65044"
              r=".42213"
              style="display:inline;fill:url(#linearGradient17481)"
            />
          </g>
          <g id="indicator-ok" transform="translate(-.0017504 -.045599)">
            <circle
              class="cls-6"
              cx=".60064"
              cy=".65044"
              r=".42213"
              style="display:inline;fill:url(#linearGradient17618)"
            />
          </g>
          <g id="indicator-verylow" transform="matrix(1,0,0,-1,2.1766,38.098)">
            <polygon
              class="cls-14"
              transform="matrix(-.04603 -.04603 .04603 -.04603 -5.7232 43.229)"
              points="23.77 113.98 6.66 104.85 13.29 103.41 14.77 96.7"
              style="fill:#ff0000"
            />
            <path
              class="cls-15"
              transform="matrix(-.04603 -.04603 .04603 -.04603 -5.7232 43.229)"
              d="m14.77 96.7-1.48 6.71 10.48 10.57z"
              style="fill:#df2020"
            />
          </g>
          <g id="indicator-low" transform="translate(.013591 -.025615)">
            <polygon
              class="cls-14"
              transform="matrix(.070004 0 0 .070004 -.47982 -6.7438)"
              points="6.66 104.85 13.29 103.41 14.77 96.7 23.77 113.98"
              style="fill:#ffff00"
            />
            <path
              class="cls-15"
              d="m0.55414 0.025615-0.10361 0.46973 0.73365 0.73995z"
              style="fill:#d9e021"
            />
          </g>
          <g id="indicator-high" transform="matrix(1 0 0 -1 .013591 1.2353)">
            <polygon
              class="cls-14"
              transform="matrix(.070004 0 0 .070004 -.47982 -6.7438)"
              points="14.77 96.7 23.77 113.98 6.66 104.85 13.29 103.41"
              style="fill:#ffff00"
            />
            <path
              class="cls-15"
              d="m0.55414 0.025615-0.10361 0.46973 0.73365 0.73995z"
              style="fill:#d9e021"
            />
          </g>
        </g>
      </g>
    </g>
    <use
      transform="matrix(14.427 0 0 14.427 6.4878 68.735)"
      width="100%"
      height="100%"
      xlink:href="#indicator-{elwi_range}"
    /><!-- DATA Indicator ELWI-->
    <use
      transform="matrix(14.427 0 0 14.427 6.4878 97.065)"
      width="100%"
      height="100%"
      xlink:href="#indicator-{pvpi_range}"
    /><!-- DATA Indicator PVPI-->
    <use
      transform="matrix(14.427 0 0 14.427 6.4878 235.08)"
      width="100%"
      height="100%"
      xlink:href="#indicator-{gedi_range}"
    /><!-- DATA Indicator GEDI-->
    <use
      transform="matrix(14.427 0 0 14.427 6.4878 261.88)"
      width="100%"
      height="100%"
      xlink:href="#indicator-{gef_range}"
    /><!-- DATA Indicator GEF-->
    <use
      transform="matrix(14.427 0 0 14.427 6.4878 290.13)"
      width="100%"
      height="100%"
      xlink:href="#indicator-{cfi_range}"
    /><!-- DATA Indicator CFI-->
    <use
      transform="matrix(14.427 0 0 14.427 440.81 205.21)"
      width="100%"
      height="100%"
      xlink:href="#indicator-{cipc_range}"
    /><!-- DATA Indicator CI-->
    <use
      transform="matrix(14.427 0 0 14.427 440.81 235.08)"
      width="100%"
      height="100%"
      xlink:href="#indicator-{svv_range}"
    /><!-- DATA Indicator SVV-->
    <use
      transform="matrix(14.427 0 0 14.427 440.81 314)"
      width="100%"
      height="100%"
      xlink:href="#indicator-{cpi_indicator}"
    /><!-- DATA Indicator CPI-->
    <use
      transform="matrix(14.427 0 0 14.427 440.81 319.06)"
      y="5"
      width="100%"
      height="100%"
      xlink:href="#indicator-{svri_range}"
    /><!-- DATA Indicator SVRI-->
    <text
      id="desELWI"
      class="cls-10"
      x="24.50589"
      y="84.869202"
      style="fill:#f2f2f2;font-family:TrebuchetFlex, TrebuchetFlex;font-size:21px"
      >
      {dict['ELWI']}
    </text>
    <text
      class="cls-10"
      x="24.50589"
      y="113.2502"
      style="fill:#f2f2f2;font-family:TrebuchetFlex, TrebuchetFlex;font-size:21px">{dict['PVPI']}</text
    >
    <text
      class="cls-10"
      x="24.50589"
      y="223.54646"
      style="fill:#f2f2f2;font-family:TrebuchetFlex, TrebuchetFlex;font-size:21px">{dict['tdCI']}</text
    >
    <text
      class="cls-10"
      x="24.50589"
      y="251.26646"
      style="fill:#f2f2f2;font-family:TrebuchetFlex, TrebuchetFlex;font-size:21px">{dict['GEDI']}</text
    >
    <text
      class="cls-10"
      x="24.50589"
      y="278.06647"
      style="fill:#f2f2f2;font-family:TrebuchetFlex, TrebuchetFlex;font-size:21px">{dict['GEF']}</text
    >
    <text
      class="cls-10"
      x="24.50589"
      y="306.31647"
      style="fill:#f2f2f2;font-family:TrebuchetFlex, TrebuchetFlex;font-size:21px">{dict['CFI']}</text
    >
    <text
      class="cls-10"
      x="325"
      y="221.90688"
      style="fill:#f2f2f2;font-family:TrebuchetFlex, TrebuchetFlex;font-size:21px">{dict['CI']}</text
    >
    <text
      class="cls-10"
      x="325"
      y="251.21519"
      style="fill:#f2f2f2;font-family:TrebuchetFlex, TrebuchetFlex;font-size:21px">{dict['SVV']}</text
    >
    <text
      class="cls-10"
      x="325"
      y="279.23029"
      style="fill:#f2f2f2;font-family:TrebuchetFlex, TrebuchetFlex;font-size:21px">{dict['Eadyn']}</text
    >
    <text
      class="cls-10"
      x="325"
      y="330.23029"
      style="fill:#f2f2f2;font-family:TrebuchetFlex, TrebuchetFlex;font-size:21px">{dict['CPI']}</text
    >
    <text
      class="cls-10"
      x="325"
      y="355.23029"
      style="fill:#f2f2f2;font-family:TrebuchetFlex, TrebuchetFlex;font-size:21px">{dict['dpMx']}</text
    >
    <text
      class="cls-10"
      x="343.20511"
      y="407.32425"
      style="fill:#f2f2f2;font-family:TrebuchetFlex, TrebuchetFlex;font-size:21px">{dict['SVRI']}</text
    >
    <text
      class="cls-10"
      x="120.46224"
      y="85.002502"
      style="fill:#f2f2f2;font-family:TrebuchetFlex, TrebuchetFlex;font-size:21px"
      ><tspan style="text-align:end;text-anchor:end">{elwi}</tspan></text
    ><!-- DATA Value ELWI-->
    <text
      class="cls-10"
      x="439.16147"
      y="251.3485"
      style="fill:#f2f2f2;font-family:TrebuchetFlex, TrebuchetFlex;font-size:21px"
      ><tspan style="text-align:end;text-anchor:end">{svv}</tspan></text
    ><!-- DATA Value SVV-->
    <text
      class="cls-10"
      x="439.16147"
      y="221.4772"
      style="fill:#f2f2f2;font-family:TrebuchetFlex, TrebuchetFlex;font-size:21px"
      ><tspan style="text-align:end;text-anchor:end">{cipc}</tspan></text
    ><!-- DATA Value CI-->
    <text
      class="cls-10"
      x="439.16147"
      y="279.36359"
      style="fill:#f2f2f2;font-family:TrebuchetFlex, TrebuchetFlex;font-size:21px"
      ><tspan style="text-align:end;text-anchor:end">{ea_dyn}</tspan></text
    ><!-- DATA Value EAdyn-->
    <text
      class="cls-10"
      x="439.16147"
      y="330.36359"
      style="fill:#f2f2f2;font-family:TrebuchetFlex, TrebuchetFlex;font-size:21px"
      ><tspan style="text-align:end;text-anchor:end">{cpi}</tspan></text
    ><!-- DATA Value CPI-->
    <text
      class="cls-10"
      x="439.16147"
      y="355.36359"
      style="fill:#f2f2f2;font-family:TrebuchetFlex, TrebuchetFlex;font-size:21px"
      ><tspan style="text-align:end;text-anchor:end">{d_pmx}</tspan></text
    ><!-- DATA Value DPMax-->
    <text
      class="cls-10"
      x="439.16147"
      y="407.45755"
      style="fill:#f2f2f2;font-family:TrebuchetFlex, TrebuchetFlex;font-size:21px"
      ><tspan style="text-align:end;text-anchor:end">{svri}</tspan></text
    ><!-- DATA Value SVRI-->
    <text
      class="cls-10"
      x="120.46224"
      y="223.62849"
      style="fill:#f2f2f2;font-family:TrebuchetFlex, TrebuchetFlex;font-size:21px"
      ><tspan style="text-align:end;text-anchor:end">{td_cipc}</tspan></text
    ><!-- DATA Value tdCI-->
    <text
      class="cls-10"
      x="120.46224"
      y="251.3485"
      style="fill:#f2f2f2;font-family:TrebuchetFlex, TrebuchetFlex;font-size:21px"
      ><tspan style="text-align:end;text-anchor:end">{gedi}</tspan></text
    ><!-- DATA Value GEDI-->
    <text
      class="cls-10"
      x="120.46224"
      y="278.1485"
      style="fill:#f2f2f2;font-family:TrebuchetFlex, TrebuchetFlex;font-size:21px"
      ><tspan style="text-align:end;text-anchor:end">{gef_nromalized}</tspan></text
    ><!-- DATA Value GEF-->
    <text
      class="cls-10"
      x="120.46224"
      y="306.3985"
      style="fill:#f2f2f2;font-family:TrebuchetFlex, TrebuchetFlex;font-size:21px"
      ><tspan style="text-align:end;text-anchor:end">{cfi_normalized}</tspan></text
    ><!-- DATA Value CFI-->
    <text
      class="cls-10"
      x="120.46224"
      y="113.3835"
      style="fill:#f2f2f2;font-family:TrebuchetFlex, TrebuchetFlex;font-size:21px"
      ><tspan style="text-align:end;text-anchor:end">{pvpi}</tspan></text
    ><!-- DATA Value PVPI-->
  </svg>
  <div class="button" on:click={handleOpenTD}>
    <img src="/assets/organview/picco_btn_icon.svg" alt="picco-btn-icon" />
    <span>PiCCO</span>
  </div>
</div>

<style>
  .wrapper {
    position: relative;
  }
  .button {
    position: absolute;
    top: 0;
    left: 0;
    background: linear-gradient(to bottom, #383838 0%, #181818 49%, #060606 50%);
    display: inline-flex;
    gap: 8px;
    padding: 8px 12px;
    border-radius: 5px;
    cursor: pointer;
    user-select: none;
    font-size: 18px;
    border: 2px solid black;
  }
</style>
